export const IconSize = {
  12: 12,
  14: 14,
  16: 16,
  18: 18,
  20: 20,
  24: 24,
  32: 32,
  40: 40,
  48: 48,
  64: 64,
};

export const IconDirection = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
};

export const IconOrientation = {
  HORIZONTAL: 'horizontal',
  ANGLE: 'angle',
  VERTICAL: 'vertical',
};
